import { render } from "./SplitterPanel.vue?vue&type=template&id=1d647150"
import script from "./SplitterPanel.vue?vue&type=script&lang=js"
export * from "./SplitterPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__